// Lightweight client identity persisted in localStorage (mirrors the battle app's
// no-password model). The server get-or-creates the user by uuid.
import { upsertUser } from './api'

const KEY = 'tacitus.campaign.user'

export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) } catch { return null }
}

const store = (user) => {
  localStorage.setItem(KEY, JSON.stringify(user))
  return user
}

// Validate/refresh an existing user, or create one from a display name.
export const ensureUser = async (displayName) => {
  const existing = getStoredUser()
  const body = existing
    ? { uuid: existing.uuid, displayName: displayName || existing.displayName }
    : { displayName }
  const user = await upsertUser(body)
  return store(user)
}
